<template>
  <div
    class="card-header blueHeader"
    :style="cardHeaderBackgroundColor"
    @click="hideBlock($event)">
    {{ $t(label) }}
    <i class="fa-light fa-chevron-right">chevron_right</i>
  </div>
</template>
<script>
/* TLV 12/03/2020
* @brief Component qui gère les headers des cartes (utile pour éviter de faire du copié
* sur le dashboard par exemple)
* @param label est la seule propriété demandée, permettant de savoir quel label afficher sur le header
*/
export default {
  name: 'CardHeader',
  props: {
    label: {
      type: String,
      default: 'common.status.accepted_request'
    }
  },
  mounted () {
    // Chevrons dirigés vers le bas la sur version web
    if (!this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.$$('.headerChevron').transform('rotate(90deg)')
    }
  },
  methods: {
    // On cache le formulaire lors d'un clic sur le card header
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('card-header')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
          that.Dom7($event.target).find('i').transform('rotate(90deg)')
        } else {
          that.Dom7($event.target).next().hide()
          that.Dom7($event.target).find('i').transform('rotate(0deg)')
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
          that.Dom7($event.target).parent().find('i').transform('rotate(90deg)')
        } else {
          that.Dom7($event.target).parent().next().hide()
          that.Dom7($event.target).parent().find('i').transform('rotate(0deg)')
        }
      }
      that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top + that.$$(that.$$('.page-content')[that.$$('.page-content').length - 1]).offset().top - 96, 400)
    }
  },
  computed: {
    // TLV 12/03/2020 : La couleur de fond de la carte et des bordures des tableaux de stats dépendent du service
    cardHeaderBackgroundColor () {
      return {backgroundColor: this.$engine.services.getCardBackgroundColor(this.$engine.user.currentService.id)}
    }
  }
}
</script>
